import { PAGE_KINDS } from "../shared/constants/pageAgentIds";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { enumStringNode, isRefusal, refuse, requiredString, type FrontendTool } from "./frontendTool";

/** Opens one of the Case Review's panels (queries, follow-up changes, linked cases). */
export const openPanelTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.openPanel,
  declaration: (location, caseReview) => location?.page !== PAGE_KINDS.caseReview || caseReview === null ? null : {
    name: FRONTEND_TOOL_NAMES.openPanel,
    description: "Open one of the case's panels in place of the section.",
    parameters: {
      type: "object",
      properties: { panelId: enumStringNode(caseReview.panelIds) },
      required: ["panelId"],
    },
  },
  execute: (args, env) => {
    const panelId = requiredString(args, "panelId");
    if (isRefusal(panelId)) return panelId;
    if (env.caseReview === null) return refuse(FRONTEND_TOOL_CODES.outOfScope, "No case is open on this screen.");
    if (!env.caseReview.panelIds.includes(panelId)) return refuse(FRONTEND_TOOL_CODES.outOfScope, `${panelId} is not a panel of the case.`);
    env.caseReview.setActivePanelId(panelId);
    return { ok: true, panelId };
  },
};
